export default __webpack_public_path__ + "static/media/sd-404.7ddc79d1.gif";